import React from "react";
import styles from "./LoginModal.module.scss";
import CloseModalIconOpacity from "../../icons/profile/closeModalOpacity";
import LogoIcon from "../../icons/Logo";
import Button from "../Button/Button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoginModal } from "../../../store/slices/modals.slice";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/store";

const LoginModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loginModal = useAppSelector((state: any) => state.modals.loginModal);
  const title = typeof loginModal === "string" ? t(loginModal) : t("loginModal1");

  const closeModal = () => {
    localStorage.setItem("trailerViewCount", "0");
    dispatch(setLoginModal(false));
  };

  return (
    <div
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          closeModal();
        }
      }}
      className={styles.modalWrapper}
    >
      <div className={styles.modalContentWrapper}>
        <div onClick={closeModal} className={styles.closeIconWrapper}>
          <CloseModalIconOpacity />
        </div>
        <div className={styles.loginBlock}>
          <div className={styles.loginLogo}>
            <LogoIcon width={106} height={24} />
          </div>
          <div className={styles.loginTitle}>{title}</div>
          <div className={styles.loginHolder}>
            <Link onClick={closeModal} to={"/login"} className={styles.loginButtonWrapper}>
              <Button className={styles.loginButton} title={t("loginModal2")} submit="" />
            </Link>
            <div className={styles.loginSeparator}>
              <span>{t("tip3")}</span>
            </div>
            <Link onClick={closeModal} to={"/login"} className={styles.loginButtonWrapper}>
              <Button className={styles.loginButtonAutorization} title={t("loginModal3")} submit="" />
            </Link>
          </div>

          <div className={styles.loginDescription}>
            {t("loginTerms4")} <Link to={"/agreement"}>{t("loginTerms5")}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
